export default function CCTerritoryManageSidebarIcon() {
  return (
    <>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.92739 12.7017H17.073M2.92709 7.70166H17.0728M17.5 10.2017C17.5 14.3438 14.1421 17.7017 10 17.7017C5.85786 17.7017 2.5 14.3438 2.5 10.2017C2.5 6.05952 5.85786 2.70166 10 2.70166C14.1421 2.70166 17.5 6.05952 17.5 10.2017ZM13.125 10.2017C13.125 14.2326 11.7259 17.5003 10 17.5003C8.27411 17.5003 6.875 14.2326 6.875 10.2017C6.875 6.17072 8.27411 2.90299 10 2.90299C11.7259 2.90299 13.125 6.17072 13.125 10.2017Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
      </svg>
    </>
  );
}
